import { render, staticRenderFns } from "./Prevent.vue?vue&type=template&id=3b38bcc8&scoped=true&"
import script from "./Prevent.vue?vue&type=script&lang=js&"
export * from "./Prevent.vue?vue&type=script&lang=js&"
import style0 from "./Prevent.vue?vue&type=style&index=0&id=3b38bcc8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b38bcc8",
  null
  
)

export default component.exports